/**
 * This is just a simple version of deep copy
 * Has a lot of edge cases bug
 * If you want to use a perfect deep copy, use lodash's _.cloneDeep
 */
import Browser from "./browser";
import gameConfig from "../config/game.js";
import preload from "./preload";
import ifmTool from "./ifmTool";
const screenfull = require("screenfull");
const md5 = require("md5");
const browser = new Browser();

String.prototype.replaceAll = function(s1, s2) {
    return this.replace(new RegExp(s1, "gm"), s2);
};

/**生成随机数 */
export function randomNum(minNum, maxNum) {
    switch (arguments.length) {
        case 1:
            return parseInt(Math.random() * minNum + 1, 10);
        case 2:
            return parseInt(Math.random() * (maxNum - minNum + 1) + minNum, 10);
        default:
            return 0;
    }
}

/**根据identity生成唯一的id */
export function getRandomId(identity) {
    return md5(identity) + randomNum(1000, 9999) + new Date().getTime();
}

export function deepClone(source) {
    if (!source && typeof source !== "object") {
        throw new Error("error arguments", "shallowClone");
    }
    const targetObj = source.constructor === Array ? [] : {};
    Object.keys(source).forEach((keys) => {
        if (source[keys] && typeof source[keys] === "object") {
            targetObj[keys] = deepClone(source[keys]);
        } else {
            targetObj[keys] = source[keys];
        }
    });
    return targetObj;
}

export function uniqueArr(arr) {
    return Array.from(new Set(arr));
}

export function resetRem() {
    var doc = window.document;
    var docEl = doc.documentElement;
    var width = docEl.getBoundingClientRect().width,
        height = docEl.getBoundingClientRect().height;

    height = height < width ? height : width;
    height = height > 720 ? 720 : height;
    let rem = height / 3.6; //1280*720
    rem = browser.isIPad() ? rem * 0.75 : rem;
    docEl.style.fontSize = rem + "px";
    window.__REM__ = rem;
}

export function setFullScreenStatus(status) {
    localStorage.setItem("fullScreenStatus", status);
}

export function setFullScreenIsEnabled(enabled) {
    localStorage.setItem("allowFullScreen", enabled ? 1 : 0);
}

/**获取Screenfull对象 */
export function getScreenfull() {
    return screenfull;
}

/**全屏按钮初始化 */
export function fullScreenInit(showFullscreenBtn, isApp) {
    if (
        (browser.isIos() ||
            !screenfullIsEnabled() ||
            showFullscreenBtn == 1 ||
            isApp == 1) &&
        browser.getPlatform() == 0
    ) {
        setFullScreenIsEnabled(false);
    } else {
        setFullScreenIsEnabled(true);
        setFullScreenStatus(screenfull.isFullscreen ? 1 : 0);
    }
    if (screenfull.isEnabled) {
        screenfull.on("change", () => {
            setFullScreenStatus(screenfull.isFullscreen ? 1 : 0);
            ifmTool.postFullSceenInfo(screenfull.isFullscreen ? 1 : 0);
        });
    }
}

//打开新窗口链接
export function openUrl(url) {
    if (browser.getPlatform() == 0) {
        window.open(url);
    } else {
        window.nativeUtils.openURL(url);
    }
}

//当前是否是全屏状态
export function isFullscreen() {
    return screenfull.isFullscreen;
}

//允许全屏
export function screenfullIsEnabled() {
    return screenfull.isEnabled;
}

//全屏状态切换
export function toggleFullScreen() {
    screenfull.toggle(document.body);
}

//判断是不是Ip访问
export function isIP(ip) {
    var pattIp = /^(([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])\.){3}([0-9]|[1-9][0-9]|1[0-9]{2}|2[0-4][0-9]|25[0-5])[:]?[0-9]*$/;
    return pattIp.test(ip);
}

export function cleanArray(actual) {
    const newArray = [];
    for (let i = 0; i < actual.length; i++) {
        if (actual[i]) {
            newArray.push(actual[i]);
        }
    }
    return newArray;
}

export function param(json) {
    if (!json) return "";
    return cleanArray(
        Object.keys(json).map((key) => {
            if (json[key] === undefined) return "";
            return encodeURIComponent(key) + "=" + encodeURIComponent(json[key]);
        })
    ).join("&");
}

export function param2Obj(url) {
    const search = url.split("?")[1];
    if (!search) {
        return {};
    }
    return JSON.parse(
        '{"' +
        decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"') +
        '"}'
    );
}

// 根据文件名后缀区分 文件类型
/*
 * @param: fileName - 文件名称
 * @param: 数据返回 1) 无后缀匹配 - false
 * @param: 数据返回 2) 匹配图片 - image
 * @param: 数据返回 3) 匹配 txt - txt
 * @param: 数据返回 4) 匹配 excel - excel
 * @param: 数据返回 5) 匹配 word - word
 * @param: 数据返回 6) 匹配 pdf - pdf
 * @param: 数据返回 7) 匹配 ppt - ppt
 * @param: 数据返回 8) 匹配 视频 - video
 * @param: 数据返回 9) 匹配 音频 - audio
 * @param: 数据返回 10) 其他匹配项 - other
 */
export function matchType(fileName) {
    // 后缀获取
    var suffix = "";
    // 获取类型结果
    var result = "";
    try {
        var flieArr = fileName.split(".");
        suffix = flieArr[flieArr.length - 1];
    } catch (err) {
        suffix = "";
    }
    // fileName无后缀返回 false
    if (!suffix) {
        result = false;
        return result;
    }
    // 图片格式
    var imglist = ["png", "jpg", "jpeg", "bmp", "gif"];
    // 进行图片匹配
    result = imglist.some(function(item) {
        return item == suffix;
    });
    if (result) {
        result = "image";
        return result;
    }
    //base64格式的图片匹配
    if (new RegExp("data:image/(jpeg|png|gif);base64").test(fileName)) {
        result = "image";
        return result;
    }
    // 匹配txt
    var txtlist = ["txt"];
    result = txtlist.some(function(item) {
        return item == suffix;
    });
    if (result) {
        result = "txt";
        return result;
    }
    // 匹配 excel
    var excelist = ["xls", "xlsx"];
    result = excelist.some(function(item) {
        return item == suffix;
    });
    if (result) {
        result = "excel";
        return result;
    }
    // 匹配 word
    var wordlist = ["doc", "docx"];
    result = wordlist.some(function(item) {
        return item == suffix;
    });
    if (result) {
        result = "word";
        return result;
    }
    // 匹配 pdf
    var pdflist = ["pdf"];
    result = pdflist.some(function(item) {
        return item == suffix;
    });
    if (result) {
        result = "pdf";
        return result;
    }
    // 匹配 ppt
    var pptlist = ["ppt"];
    result = pptlist.some(function(item) {
        return item == suffix;
    });
    if (result) {
        result = "ppt";
        return result;
    }
    // 匹配 视频
    var videolist = ["mp4", "m2v", "mkv"];
    result = videolist.some(function(item) {
        return item == suffix;
    });
    if (result) {
        result = "video";
        return result;
    }
    // 匹配 音频
    var radiolist = ["mp3", "wav", "wmv"];
    result = radiolist.some(function(item) {
        return item == suffix;
    });
    if (result) {
        result = "audio";
        return result;
    }
    //匹配base64格式的音频文件
    //base64格式的图片匹配
    if (new RegExp("data:audio/mpeg;base64").test(fileName)) {
        result = "audio";
        return result;
    }
    // 其他 文件类型
    result = "other";
    return result;
}

//通过gameID预加载音频资源
export function preloadResByGameID(gameID) {
    let preSounds = [];
    for (let i = 0; i < gameConfig.length; i++) {
        if (gameConfig[i].gameID == gameID) {
            for (let key in gameConfig[i]) {
                if (key != "gameID" && key != "gameName") {
                    preSounds.push(gameConfig[i][key]);
                }
            }
            break;
        }
    }
    if (preSounds.length > 0) {
        new preload(preSounds);
    }
}

//通过gameID获取对应的gameName
export function getGameNameById(gameID) {
    let gameName = gameID;
    for (let i = 0; i < gameConfig.length; i++) {
        if (gameConfig[i].gameID == gameID) {
            gameName = gameConfig[i]["gameName"];
            break;
        }
    }
    return gameName;
}

//打乱数组顺序
export function shuffle(arrOld) {
    let arr = deepClone(arrOld);
    var len = arr.length;
    for (var i = 0; i < len; i++) {
        var end = len - 1;
        var index = (Math.random() * (end + 1)) >> 0;
        var t = arr[end];
        arr[end] = arr[index];
        arr[index] = t;
    }
    return arr;
}